import React, { Component } from 'react';
import {
  Row, Col, Button, Form, Radio, Divider, Icon, Tabs,
} from 'antd';
import { FormControl, FormRules } from 'form-control';
import PropTypes from 'prop-types';
import autobind from 'react-autobind';
import { formPropType } from 'utils/propType';
import translate from 'app/translations';
import AgentProfilePropType, { messageShape } from '../AgentProfilePropType';
import StatusTooltip from './StatusTooltip';
import ConfirmApprove from './ConfirmApprove';
import MessageList from './MessageList';
import PostMessage from './PostMessage';

const APPROVED_STATUS = 'APPROVED';
const IN_PROGRESS_STATUS = 'IN_PROGRESS';

const RadioGroup = Radio.Group;
const { TabPane } = Tabs;

export class ApplicationStatus extends Component {
  constructor(props) {
    super(props);
    autobind(this);
    this.t = translate;
  }

  handleUpdate() {
    const { form } = this.props;
    form.validateFieldsAndScroll((errors, values) => {
      if (!errors) {
        const { status } = values;
        if (status === APPROVED_STATUS) {
          this.props.onApproveApplicationRequest(status);
        } else {
          this.props.onUpdateApplicationStatusRequest(status);
        }
      }
    });
  }

  render() {
    const { form } = this.props;

    const { agentProfile } = this.props;

    const {
      status, constants, isCallInprogress, userProfile,
    } = agentProfile;

    const {
      STATUS,
    } = constants;

    return (
      <div>
        <div className="card-container responsive-border">
          <div>

            <h2 className="float-left orange-text">
              {status === APPROVED_STATUS ? this.t('ApplicationStatus.approved') : this.t('ApplicationStatus.heading')}
            </h2>
            <div className="float-right">
              <div className="align-right">
                <h3 className="margin-padding-zero">
                  <strong> {userProfile.firstName} {userProfile.lastName} </strong>
                </h3>
                <div>
                  <div className="inline-block space-between">
                    <span>{this.t('Generic.phone')} <Icon type="phone" />: </span>
                    <a href={`tel:+${userProfile.alternatePhone}`}>{userProfile.alternatePhone}</a>
                    {userProfile.alternatePhoneExt && (
                      <span> x {userProfile.alternatePhoneExt} </span>
                    )}
                  </div>
                  <div className="inline-block space-between">
                    <span>{this.t('Generic.mobile')} <Icon type="tablet" /> : </span>
                    <a href={`tel:+${userProfile.mobile}`}>{userProfile.mobile}</a>
                  </div>
                  <div className="inline-block space-between">
                    <span>{this.t('Generic.email')} <Icon type="mail" /> : </span>
                    <a href={`mailto:${userProfile.email}`}>{userProfile.email} </a>
                  </div>
                </div>
              </div>
            </div>
            <Divider />
          </div>

          <Tabs defaultActiveKey="1">
            <TabPane tab={this.t('ApplicationStatus.tab1')} key="1">

              <Form layout="vertical">
                {status === APPROVED_STATUS && (
                  <ConfirmApprove />
                )}
                {status !== APPROVED_STATUS && (
                  <div>
                    <Row gutter={16}>
                      <Col md={24} lg={20}>
                        <p className="emphasized-text">
                          {this.t('ApplicationStatus.infoTextStart')}
                          <StatusTooltip
                            agentProfile={agentProfile}
                          />
                          {this.t('ApplicationStatus.infoTextEnd')}
                        </p>

                        <FormControl
                          form={form}
                          fieldName="status"
                          hideLabel
                          rules={[FormRules.REQUIRED]}
                          className="margin-zero radio-grid"
                          displayName={this.t('ApplicationsDashboard.ApplicationList.status')}
                          initialValue={status || undefined}
                        >
                          <RadioGroup
                            options={
                              STATUS.map(kv => ({ label: kv.name, value: kv.value }))
                                .filter(kv => kv.value !== IN_PROGRESS_STATUS)
                            }
                          />
                        </FormControl>
                      </Col>
                      <Col
                        className="align-right"
                        style={{ paddingBottom: 24 }}
                        md={24}
                        lg={20}
                      >
                        <Button
                          type="primary"
                          htmlType="submit"
                          id="search"
                          className="btn-inline-form"
                          onClick={this.handleUpdate}
                          disabled={isCallInprogress}
                        >
                          {this.t('Generic.update')}
                        </Button>
                      </Col>
                    </Row>
                  </div>
                )}
              </Form>
              <Row gutter={16}>
                <Col md={24} lg={20} style={{ paddingTop: 24 }}>
                  <PostMessage
                    onAddMessage={this.props.onAddApplicationMessageRequest}
                  />
                </Col>
              </Row>
            </TabPane>
            <TabPane tab={this.t('ApplicationStatus.tab2')} key="2">
              <Row gutter={16}>
                <Col md={24} lg={20} style={{ paddingTop: 24 }}>
                  <div className="card-container">
                    <MessageList messageList={this.props.messageList} />
                  </div>
                </Col>
              </Row>
            </TabPane>
          </Tabs>
        </div>
      </div>
    );
  }
}

ApplicationStatus.propTypes = {
  form: PropTypes.shape(formPropType).isRequired,
  agentProfile: PropTypes.shape(AgentProfilePropType).isRequired,
  onUpdateApplicationStatusRequest: PropTypes.func.isRequired,
  onApproveApplicationRequest: PropTypes.func.isRequired,
  messageList: PropTypes.arrayOf(messageShape).isRequired,
  onAddApplicationMessageRequest: PropTypes.func.isRequired,
};

export default Form.create()(ApplicationStatus);
